<template>
    <div>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                     <el-form-item label="学生姓名:" prop="studentName">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.studentName" placeholder="请输入学生姓名"></el-input>
                    </el-form-item>
                     <el-form-item label="身份证号:" prop="idCard">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.idCard" placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                     <el-form-item label="填报日期:" prop="dayTime">
                         <el-date-picker
                                 v-model="searchForm.dayTime"
                                 type="date"
                                 size="mini"
                                 placeholder="选择填报日期"
                                 value-format="yyyy-MM-dd"
                                 format="yyyy-MM-dd">
                         </el-date-picker>
                    </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudentSituation-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysStudentSituation-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysStudentSituation-censusStudentSituation icon="el-icon-s-data" @click="censusStudentSituation" >疫情情况统计</el-button>
                    <el-dropdown>
                         <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                             批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                         </el-button>
                         <el-dropdown-menu slot="dropdown">
                             <el-dropdown-item v-display:sysStudentSituation-batchDelete icon="el-icon-delete" @click.native="batchDelete">批量删除</el-dropdown-item>
                             <el-dropdown-item v-display:sysStudentSituation-batchUpdate icon="el-icon-delete" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                             <el-dropdown-item v-display:sysStudentSituation-leadingIn icon="el-icon-upload" @click.native="leadingInSysStudentSituation">导入</el-dropdown-item>
                             <el-dropdown-item v-display:sysStudentSituation-export icon="el-icon-download" @click.native="exportSysStudentSituation">导出</el-dropdown-item>
                             <el-dropdown-item v-display:sysStudentSituation-exportField icon="el-icon-download" @click.native="exportSysStudentSituationDialog">导出选择字段</el-dropdown-item>
                             <el-dropdown-item v-display:sysStudentSituation-exportModule icon="el-icon-download" @click.native="exportSysStudentSituationModule('upsertForm')">下载模板</el-dropdown-item>
                         </el-dropdown-menu>
                     </el-dropdown>
                </el-form-item>
            </el-form>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column show-overflow-tooltip prop="studentName" label="学生姓名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="currentAddress" label="现身处地详细地址"></el-table-column>
            <el-table-column show-overflow-tooltip prop="highRiskStaus" label="现是否处于中高风险地区"></el-table-column>
            <el-table-column show-overflow-tooltip prop="highRiskAddress" label="身处风险地区名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="isolation" label="隔离情况"></el-table-column>
            <el-table-column show-overflow-tooltip prop="isolationTime" label="隔离/封控起止时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="examStatus" label="预估能否参加现场考试"></el-table-column>
            <el-table-column show-overflow-tooltip prop="dayTime" label="填报日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-display:sysStudentSituation-update @click.native="showUpdateDialog(scope.row.id)">修改</el-dropdown-item>
                            <el-dropdown-item v-display:sysStudentSituation-look @click.native="toLook($event,scope.row.id)">查看</el-dropdown-item>
                            <el-dropdown-item v-display:sysStudentSituation-delete @click.native="deleteData(scope.row.id)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="1000px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" label-position="top" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                  <el-form-item label="学生姓名" prop="studentName">
                     <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.studentName" placeholder="请输入学生姓名" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="身份证号" prop="idCard">
                     <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.idCard" placeholder="请输入身份证号" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="现身处地详细地址" prop="currentAddress">
                     <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.currentAddress" placeholder="请输入现身处地详细地址" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="现是否处于中高风险地区" prop="highRiskStaus">
                     <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.highRiskStaus" placeholder="请输入现是否处于中高风险地区" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="身处风险地区名称" prop="highRiskAddress">
                     <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.highRiskAddress" placeholder="请输入身处风险地区名称" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="隔离情况" prop="isolation">
                     <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.isolation" placeholder="请输入隔离情况" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="隔离/封控起止时间" prop="isolationTime">
                     <el-input size="mini" maxlength="100" show-word-limit  v-model="upsertForm.isolationTime" placeholder="请输入隔离/封控起止时间" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="预估能否参加现场考试" prop="examStatus">
                     <el-input size="mini" maxlength="100" show-word-limit  v-model="upsertForm.examStatus" placeholder="请输入预估能否参加现场考试" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="填报日期" prop="dayTime">
                      <el-date-picker
                              v-model="upsertForm.dayTime"
                              type="date"
                              size="mini"
                              placeholder="选择填报日期"
                              value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd">
                      </el-date-picker>
                 </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysStudentSituation-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysStudentSituation-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="1000px" :visible.sync="lookVisible">
            <div>
                <el-form class="upsertForm" label-position="top" :inline="true" label-width="100px">
                    <el-form-item label="学生姓名" prop="studentName">
                        <el-input size="mini" v-model="upsertForm.studentName" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="idCard">
                        <el-input size="mini" v-model="upsertForm.idCard" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="现身处地详细地址" prop="currentAddress">
                        <el-input size="mini" v-model="upsertForm.currentAddress" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="现是否处于中高风险地区" prop="highRiskStaus">
                        <el-input size="mini" v-model="upsertForm.highRiskStaus" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="身处风险地区名称" prop="highRiskAddress">
                        <el-input size="mini" v-model="upsertForm.highRiskAddress" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="隔离情况" prop="isolation">
                        <el-input size="mini" v-model="upsertForm.isolation" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="隔离/封控起止时间" prop="isolationTime">
                        <el-input size="mini" v-model="upsertForm.isolationTime" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="预估能否参加现场考试" prop="examStatus">
                        <el-input size="mini" v-model="upsertForm.examStatus" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="填报日期" prop="dayTime">
                        <el-input size="mini" v-model="upsertForm.dayTime" readonly auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <!--批量修改-->
        <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="900px" :visible.sync="batchDialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                <el-form-item label="学生姓名" prop="studentName">
                    <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.studentName" placeholder="请输入学生姓名" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard">
                    <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.idCard" placeholder="请输入身份证号" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="现身处地详细地址" prop="currentAddress">
                    <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.currentAddress" placeholder="请输入现身处地详细地址" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="现是否处于中高风险地区" prop="highRiskStaus">
                    <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.highRiskStaus" placeholder="请输入现是否处于中高风险地区" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="身处风险地区名称" prop="highRiskAddress">
                    <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.highRiskAddress" placeholder="请输入身处风险地区名称" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="隔离情况" prop="isolation">
                    <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.isolation" placeholder="请输入隔离情况" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="隔离/封控起止时间" prop="isolationTime">
                    <el-input size="mini" maxlength="100" show-word-limit  v-model="upsertForm.isolationTime" placeholder="请输入隔离/封控起止时间" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="预估能否参加现场考试" prop="examStatus">
                    <el-input size="mini" maxlength="100" show-word-limit  v-model="upsertForm.examStatus" placeholder="请输入预估能否参加现场考试" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="填报日期" prop="dayTime">
                    <el-date-picker
                            v-model="upsertForm.dayTime"
                            type="date"
                            size="mini"
                            placeholder="选择填报日期"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
            <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                <el-button size="mini">导入总数</el-button>
            </el-badge>
            <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入成功</el-button>
            </el-badge>
            <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入失败</el-button>
            </el-badge>
            <!--表格-->
            <el-table border size="mini" v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                        <el-table-column show-overflow-tooltip prop="studentName" label="学生姓名"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="currentAddress" label="现身处地详细地址"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="highRiskStaus" label="现是否处于中高风险地区"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="highRiskAddress" label="身处风险地区名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="isolation" label="隔离情况"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="isolationTime" label="隔离/封控起止时间"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="examStatus" label="预估能否参加现场考试"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="dayTime" label="填报日期"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                   style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                   :action="uploadUrl"
                   :headers="headers"
                   multiple
                   :show-file-list="false"
                   :on-success="handleSysStudentSituationSuccess"
                   :before-upload="beforeSysStudentSituationUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportSysStudentSituationModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
           <div style="height: 400px;overflow-y: auto;width: 100%" >
               <!--表格-->
               <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                   <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                   <el-table-column prop="key" label="英文字段名" ></el-table-column>
                   <el-table-column prop="name" label="中文字段名" ></el-table-column>
                   <el-table-column prop="newName" label="重命名字段" >
                       <template slot-scope="scope">
                           <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                       </template>
                   </el-table-column>
               </el-table>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysStudentSituationByField">确认导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysStudentSituation",
        components: { noData },
        data() {
            return {
                searchForm:{
                      studentId: '',
                      studentName: '',
                      idCard: '',
                      currentAddress: '',
                      highRiskStaus: '',
                      highRiskAddress: '',
                      isolation: '',
                      isolationTime: '',
                      examStatus: '',
                      dayTime: '',
                      updateTime: '',
                      createTime: '',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0
                    }
                },
                tableData: [],
                upsertForm:{
                        id:'',
                        studentId:'',
                        studentName:'',
                        idCard:'',
                        currentAddress:'',
                        highRiskStaus:'',
                        highRiskAddress:'',
                        isolation:'',
                        isolationTime:'',
                        examStatus:'',
                        dayTime:'',
                        updateTime:'',
                        createTime:''
                },
                searchRules: {
                          studentId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          currentAddress: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          highRiskStaus: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          highRiskAddress: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          isolation: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          isolationTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examStatus: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          dayTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                rules: {
                          studentId: [
                                  { required: true, message: '请输入学生编号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentName: [
                                  { required: true, message: '请输入学生姓名', trigger: 'blur' },
                                  {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  { required: true, message: '请输入身份证号', trigger: 'blur' },
                                  {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                              ],
                          currentAddress: [
                                  { required: true, message: '请输入现身处地详细地址', trigger: 'blur' },
                                  {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                              ],
                          highRiskStaus: [
                                  { required: true, message: '请输入现是否处于中高风险地区', trigger: 'blur' },
                                  {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                              ],
                          highRiskAddress: [
                                  { required: true, message: '请输入身处风险地区名称', trigger: 'blur' },
                                  {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                              ],
                          isolation: [
                                  { required: true, message: '请输入隔离情况', trigger: 'blur' },
                                  {  max: 100, message: '长度必须少于100个字符', trigger: 'blur' }
                              ],
                          isolationTime: [
                                  { required: true, message: '请输入隔离/封控起止时间', trigger: 'blur' },
                                  {  max: 100, message: '长度必须少于100个字符', trigger: 'blur' }
                              ],
                          examStatus: [
                                  { required: true, message: '请输入预估能否参加现场考试', trigger: 'blur' },
                                  {  max: 100, message: '长度必须少于100个字符', trigger: 'blur' }
                              ],
                          dayTime: [
                                  { required: true, message: '请输入填报日期', trigger: 'blur' },
                              ],
                          updateTime: [
                                  { required: true, message: '请输入修改时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysStudentSituation/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                batchDialog:{
                    dialogFormVisible:false,
                    title:'批量修改'
                },
            }
        },
        created(){
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysStudentSituation/update/findSysStudentSituationById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudentSituation/${this.dialog.title==='增加'?'saveSysStudentSituation':'update/updateSysStudentSituation'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentSituation/deleteSysStudentSituation/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysStudentSituation/findSysStudentSituationsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysStudentSituation/look/lookSysStudentSituationById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInSysStudentSituation() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysStudentSituation() {
                axios({
                    url: `${home}/sysStudentSituation/exportSysStudentSituation`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "疫情防控信息列表导出.xls");
                });
            },
            exportSysStudentSituationModule() {
                axios({
                    url: `${home}/sysStudentSituation/exportSysStudentSituationModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "疫情防控信息导入模板.xls");
                });

            },
            handleSysStudentSituationSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysStudentSituationUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentSituation/batchDeleteSysStudentSituation`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysStudentSituationDialog(){
                axios({
                    url: `${home}/sysStudentSituation/getSysStudentSituationTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });

            },
            exportSysStudentSituationByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysStudentSituation/exportSysStudentSituationByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "疫情防控信息选择字段导出.xls");
                    });
                }

            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysStudentSituation/batchUpdateSysStudentSituation`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            censusStudentSituation() {
                axios({
                    url: `${home}/sysStudentSituation/censusStudentSituation`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "疫情防控情况统计.xls");
                });
            },
        }
    }
</script>
